module.exports = __webpack_public_path__ + "img/3-1.92a8a3fd.png";